import { frontendURL } from 'dashboard/helper/URLHelper';
import EventInboxView from './EventInboxView.vue';
import EventInboxEmptyState from './EventInboxEmptyState.vue';
import EventInboxDetail from './EventInboxDetail.vue';

const EVENT_INBOX_PERMISSIONS = ['administrator', 'agent'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/event-inbox'),
    component: EventInboxView,
    meta: {
      permissions: EVENT_INBOX_PERMISSIONS,
    },
    children: [
      {
        path: '',
        name: 'event_inbox',
        component: EventInboxEmptyState,
        meta: {
          permissions: EVENT_INBOX_PERMISSIONS,
        },
      },
      {
        path: ':eventId',
        name: 'event_inbox_event',
        component: EventInboxDetail,
        meta: {
          permissions: EVENT_INBOX_PERMISSIONS,
        },
        props: route => ({
          eventId: route.params.eventId,
          conversationId: null,
        }),
      },
      {
        path: ':eventId/conversations/:conversationId',
        name: 'event_inbox_conversation',
        component: EventInboxDetail,
        meta: {
          permissions: EVENT_INBOX_PERMISSIONS,
        },
        props: route => ({
          eventId: route.params.eventId,
          conversationId: route.params.conversationId,
        }),
      },
    ],
  },
];
